/**
 * Local replacement for action-typed (malware-flagged package removed in Ticket 2.6).
 * Provides type-safe Redux action creators and discriminated union types.
 */

/**
 * Map of action types to action shapes for a Messages map.
 * Call sites use `TypeMap = ActionMap<Messages>` and `Actions = TypeMap[keyof TypeMap]`.
 * Each entry is { type: K; payload: Messages[K] }.
 */
export type ActionMap<Messages extends Record<string, unknown>> = {
    [K in keyof Messages]: { type: K; payload: Messages[K] };
};

/**
 * Creates a single action creator function that matches the action-typed API:
 * - Msg('Action.Type') for void/undefined payload
 * - Msg('Action.Type', payload) for payload actions
 * Returns { type, payload } (payload may be undefined).
 */
export function createMsg<Messages extends Record<string, unknown>>(): <K extends keyof Messages>(
    type: K,
    payload?: Messages[K],
) => { type: K; payload: Messages[K] } {
    return function (type: keyof Messages, payload?: unknown) {
        return { type, payload };
    } as <K extends keyof Messages>(type: K, payload?: Messages[K]) => { type: K; payload: Messages[K] };
}
